module.exports = __webpack_public_path__ + "img/back-arrow.239169b8.svg";